import {
  getListingById
} from "./chunk-MPUZIXB6.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/getListingById/getListingById.ts
async function getListingById2(listingId, params, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "getListingById");
  try {
    const listing = await getListingById(listingId, params, _apiConfig);
    return {
      status: "success",
      data: listing
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getListingById2 as getListingById
};
